import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../theme/useTheme.js';

/**
 * Compact icon-only theme toggle. Sun when in dark (clicking gives you
 * light), moon when in light (clicking gives you dark). Designed to
 * sit inline in the site nav between the last link and the primary
 * CTA. Honours ?picker=off as an escape hatch for client previews.
 */
export function ThemeSwitcher({ className = 'site-nav__theme' }) {
  const { theme, setTheme } = useTheme();
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    if (url.searchParams.get('picker') === 'off') return null;
  }
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      className={className}
      onClick={() => setTheme(next)}
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
    >
      {theme === 'dark' ? <Sun size={15} strokeWidth={2} /> : <Moon size={15} strokeWidth={2} />}
    </button>
  );
}
